import { Col, Container, Row } from 'react-bootstrap';
import { FrontWork } from '../interface/FrontWork';
import Stepper from './Stepper';
import FixedFooter from './FixedFooter';
import BackButton from './BackButton';
import EditingReportActionButtons from './EditingReportActionButtons';
import InitialWorkCountCard from './InitialWorkCountCard';

export interface InitialWorkCountStepLayoutProps {
  onConfirm: (count: number) => void;
}

const STEP_HEADING = 'STEP3 送信した著作物の情報を1つずつ入力してください';

export const createEmptyFrontWorks = (count: number): FrontWork[] => Array.from({ length: count }, () => ({ data: {}, disabled: true }));

const InitialWorkCountStepLayout: React.FC<InitialWorkCountStepLayoutProps> = ({ onConfirm }) => (
  <Container>
    <Row>
      <Col md={9} lg={9}>
        <Stepper activeNum={2} />
      </Col>
    </Row>
    <Row>
      <Col md={9} lg={9}>
        <h4 className="step-page-heading">{STEP_HEADING}</h4>
        <hr className="border-1-solid" />
      </Col>
    </Row>
    <Row className="m-10">
      <Col md={9} lg={9}>
        <InitialWorkCountCard onConfirm={onConfirm} />
      </Col>
    </Row>
    <FixedFooter>
      <EditingReportActionButtons backButton={<BackButton />} />
    </FixedFooter>
  </Container>
);

export default InitialWorkCountStepLayout;
